// import package
import React, { useState, useEffect } from "react";
import clsx from "classnames";

// import action
import { getorderHistory } from "../../actions/dashboardAction";

// import lib
import { dateTimeFormat } from "../../lib/dateTimeHelper";
import { transactionStatus } from "../../lib/displayStatus";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
const RecentTransaction = () => {
  // state
  const [data, setData] = useState([]);
  const [DownloadData, setDownloadData] = useState([]);
  const [loader, setLoader] = useState(true);

  // funtion
  const fetchTransaction = async () => {
    try {
      const { status, loading, result } = await getorderHistory();
      setLoader(loading);
      if (status == "success") {
        setData(result);

        const headers = [
          [
            "Date",
            "Transaction Id",
            "Trade Type",
            "Contract",
            "Price",
            "Quantity",
            "Filled / Remaining	",
            "Order Value",
            "Side",
          ],
        ];

        const download_data =
          result &&
          result.length > 0 &&
          result.map((elt) => [
            dateTimeFormat(elt.orderDate, "YYYY-MM-DD HH:mm"),
            elt._id,
            elt.orderType == "limit" ? "Limit" : "Market",
            elt.pairName,
            elt.price,
            elt.quantity,
            elt.quantity - elt.filledQuantity,
            elt.orderValue && elt.orderValue.toFixed(4),
            elt.buyorsell,
          ]);
        let download_csv = headers.concat(download_data);

        setDownloadData(download_csv);
      }
    } catch (err) {}
  };

  useEffect(() => {
    fetchTransaction();
  }, []);

  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(13);

    const title = "Order History";
    const headers = [
      [
        "Date",
        "Transaction Id",
        "Trade Type",
        "Contract",
        "Price",
        "Quantity",
        "Filled / Remaining	",
        "Order Value",
        "Side",
      ],
    ];

    const download_data =
      data &&
      data.length > 0 &&
      data.map((elt) => [
        dateTimeFormat(elt.orderDate, "YYYY-MM-DD HH:mm"),
        elt._id,
        elt.orderType == "limit" ? "Limit" : "Market",
        elt.pairName,
        elt.price,
        elt.quantity,
        elt.quantity - elt.filledQuantity,
        elt.orderValue && elt.orderValue.toFixed(4),
        elt.buyorsell,
      ]);

    let content = {
      startY: 50,
      head: headers,
      body: download_data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("orderhistory.pdf");
  };

  return (
    <div className="table-responsive">
      <br />
      <span>
        {data.length > 0 ? (
          <CSVLink data={DownloadData} filename={"orderhistory.csv"}>
            <button>Download csv</button>
          </CSVLink>
        ) : (
          ""
        )}

        {data.length > 0 ? (
          <CSVLink data={DownloadData} filename={"orderhistory.xls"}>
            <button>Download xls</button>
          </CSVLink>
        ) : (
          ""
        )}

        {data.length > 0 ? (
          <button onClick={exportPDF}>Download PDF</button>
        ) : (
          ""
        )}
      </span>
      <table className="table mb-0">
        <thead>
          <tr>
            <th>Date</th>
            <th>Transaction Id</th>
            <th>Trade Type</th>
            <th>Contract</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Filled / Remaining</th>

            <th>Order Value</th>
            <th>Side</th>
          </tr>
        </thead>
        <tbody>
          {loader && <div>Loading...</div>}
          {!loader &&
            data &&
            data.length > 0 &&
            data.map((item, key) => {
              return (
                <tr key={key}>
                  <td>{dateTimeFormat(item.createdAt, "YYYY-MM-DD HH:mm")}</td>
                  <td>{item._id}</td>
                  <td>{item.orderType == "limit" ? "Limit" : "Market"}</td>
                  <td>{item.pairName}</td>
                  <td>{item.price}</td>
                  <td>{item.quantity}</td>
                  <td>{item.quantity - item.filledQuantity}</td>
                  <td>{item.orderValue && item.orderValue.toFixed(4)}</td>
                  <td>{item.buyorsell}</td>
                </tr>
              );
            })}
          {!loader && data && data.length <= 0 && <div>No Record</div>}
        </tbody>
      </table>
    </div>
  );
};

export default RecentTransaction;
